export function shiftListIndex(listLength: number, currentIndex: number, shiftAmount: number): number {
    // Handle divide by 0 issues
    if (listLength === 0) {
        return 0;
    }
    if (currentIndex + shiftAmount < 0) {
        return listLength + ((currentIndex + shiftAmount) % listLength);
    }
    return (currentIndex + shiftAmount) % listLength;
}
